export default function WrongIcon ({ wrapperClass }) {
  return(
    <svg className={wrapperClass} fill='currentColor'
     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M18.83 16l8.59-8.59a2 2 0 00-2.83-2.83L16 13.17 7.41 4.59a2 2 0 00-2.82 2.82L13.17 16l-8.58 8.59a2 2 0 102.83 2.83L16 18.83l8.59 8.59a2 2 0 002.83-2.83z"
      data-name="Layer 57"
    ></path>
  </svg>
  )
}